import * as ACTIONS from "@/config/constants/action-types";

jest.mock("@/config/brands", () => ({
  default: jest.fn(),
  __esModule: true
}));

import actions from "@/store/actions";
import Vuex from "vuex";
import state from "@/store/state";

import { nextTick } from "vue";
jest.mock("axios");

describe("actions", () => {
  let store;
  let mockMutations;
  let commit;
  let dispatch;
  let payload = { isTrue: true, isFalse: false };


  beforeEach(() => {
    mockMutations = {
      ON_ROUTE: jest.fn(),
      ON_IS_LOADING: jest.fn(),
      ON_ADOBE_APPSTARTED: jest.fn(),
      ON_PASO_1: jest.fn(),
      ON_GRACIAS: jest.fn()
    };

    commit = jest.fn();
    dispatch = jest.fn();

    store = new Vuex.Store({
      state,
      actions,
      mutations: mockMutations
    });
  });

  it("DO_ROUTE commits ON_ROUTE and ON_IS_LOADING", async () => {
    const payload = "payload";
    store.dispatch("DO_ROUTE", payload);
    await nextTick();
    expect(mockMutations.ON_ROUTE).toHaveBeenCalledWith(state, payload);
    expect(mockMutations.ON_IS_LOADING).not.toHaveBeenCalled();
  });

  it("DO_IS_LOADING commits ON_IS_LOADING", () => {
    const payload = true;
    store.dispatch("DO_IS_LOADING", payload);
    expect(mockMutations.ON_IS_LOADING).toHaveBeenCalledWith(state, payload);
  });

  it("DO_ADOBE_APPSTARTED commits ON_ADOBE_APPSTARTED when trackClickElement is null", () => {
    const payload = "payload";
    store.state.trackClickElement = null;
    store.dispatch("DO_ADOBE_APPSTARTED", payload);
    expect(mockMutations.ON_ADOBE_APPSTARTED).toHaveBeenCalledWith(
      state,
      payload
    );
  });

  it("DO_ADOBE_APPSTARTED does not commit ON_ADOBE_APPSTARTED when trackClickElement is not null", () => {
    const payload = "payload";
    store.state.trackClickElement = "element";
    store.dispatch("DO_ADOBE_APPSTARTED", payload);
    expect(mockMutations.ON_ADOBE_APPSTARTED).not.toHaveBeenCalled();
  });

  it("DO_PASO1 commits ON_PASO_1", () => {
    const payload = "payload";

    store.dispatch("DO_PASO1", payload);
    expect(mockMutations.ON_PASO_1).toHaveBeenCalledWith(state, payload);
  });

  it("DO_LANDING_ERROR 01", async () => {
    payload.errorCode = "01";
    actions[ACTIONS.DO_LANDING_ERROR]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, 0);
  });

  it("DO_LANDING_ERROR 02", async () => {
    payload.errorCode = "02";
    actions[ACTIONS.DO_LANDING_ERROR]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, 1);
  });

  it("DO_LANDING_ERROR 03", async () => {
    payload.errorCode = "03";
    actions[ACTIONS.DO_LANDING_ERROR]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, 2);
  });

  it("DO_LANDING_ERROR otro codigo", async () => {
    payload.errorCode = "99";
    actions[ACTIONS.DO_LANDING_ERROR]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, 3);
  });

  it("DO_GRACIAS commits ON_GRACIAS", () => {
    const payload = "payload";
    store.dispatch("DO_GRACIAS", payload);
    expect(mockMutations.ON_GRACIAS).toHaveBeenCalledWith(state, payload);
  });
});
